export default {"src":"/_next/static/media/arrow=20.9e7bc39d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};